module.exports = __webpack_public_path__ + "static/img/wodejiangpin.13e3d4ba.png";